export default __webpack_public_path__ + "static/bench-976650e7a2a8eceef069e5d31a76ecb5.png";